var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39216 0.011102C4.5827 -0.0269872 4.78983 0.0329922 4.92917 0.19011L8.86107 4.63418C9.06551 4.86462 9.0414 5.21599 8.80804 5.41787C8.57372 5.61974 8.21789 5.59593 8.01443 5.36454L5.06186 2.02887V9.44486C5.06186 9.75147 4.81008 10 4.49939 10C4.18869 10 3.93692 9.75147 3.93692 9.44486V2.03935L0.985505 5.36549C0.780786 5.59593 0.425447 5.61973 0.191799 5.41691C-0.0418494 5.21503 -0.0652875 4.86366 0.139432 4.63322L4.03566 0.242491C4.11772 0.124414 4.24462 0.039669 4.39216 0.011102Z",
    fill: "#54CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.bea0a9e2fa7e5c6d2d0053d0a22d35d3.svg";
export { ForwardRef as ReactComponent };